// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./column.styl');

function parse(text, next) {
    var parseRe = /^.*(\]\[+).*$/gim;

    while ( match = parseRe.exec(text) ) {
        var inner = match[0].replace(/\]\[/g, ']</div><div class="mbgf-column-box">[').replace(/\[ \]/g, '');
        text = text.replace(match[0], '<div class="mbgf-column-row"><div class="mbgf-column-box">' + inner + '</div></div>');
        matchExists = true;
    }

    next(text);
};

function init(formRoot, meta, next) {
    next(formRoot);
}

module.exports = {
    parse: parse,
    init: init,
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/column/column.js